export enum NotTested {
	NT = 'NT',
	Zero = 'ZERO',
}
